module.exports = __webpack_public_path__ + "img/icon_beneficiary.58199198.png";